<script setup lang="ts">
import { defineProps, onMounted, ref } from "vue";

interface Props {
    modalId: string;
    showOnPageLoad: boolean;
    data: any;
}

const props = defineProps<Props>();

const open = ref(false);

const closeModal = () => {
    open.value = false;

    setCookie(`livelaud-session-${props.modalId}`, "true");
};

const setCookie = (name: string, value: string, days?: number) => {
    if (days) {
        var expires = "";
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + value + expires + "; path=/";
    } else {
        document.cookie = name + "=" + value + "; path=/";
    }
};

const getCookie = (name: string) => {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === " ") cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
};

const handleClick = () => {
    setCookie(`livelaud-session-${props.modalId}`, "true");
};

onMounted(() => {
    if (props.showOnPageLoad && !getCookie(`livelaud-session-${props.modalId}`)) {
        open.value = true;
    }
});
</script>

<template>
    <div :id="modalId">
        <div v-if="open" class="modal-holder fixed top-0 left-0 w-full h-full backdrop-blur-sm z-[1000] px-[20px] md:px-[32px] py-[64px] flex items-center justify-center cursor-pointer" @click="closeModal()">
            <div class="bg-brown-100 md:rounded-[4px] p-[32px] w-full z-[300] max-w-[560px] text-left relative border-2 border-beige-200" @click.stop>
                <fa-icon icon="close" class="text-15 text-beige-200 absolute right-[32px] top-[32px]" @click="closeModal()" />

                <div class="text-white font-bold mb-[16px] text-40" v-html="data.title"></div>
                <div v-if="data.sub_title" class="text-white font-medium mb-[16px] text-20" v-html="data.sub_title"></div>
                <div v-if="data.description" class="text-beige-100/80 pt-[16px] mb-[16px]" :class="{ 'pb-[16px]': !!data.link }" v-html="data.description"></div>

                <a v-if="data.link" class="flex flex-row items-center gap-8" @click="handleClick" :class="data.link.class" :href="data.link.url" :target="[data.link.target == '0' ? '_blank' : '_self']">
                    {{ data.link.title }}
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
.link-unstyled {
    @apply bg-white text-brown-200 relative font-helv font-bold text-center leading-[24px] h-[48px] px-[48px] border border-white hover:bg-none hover:text-white justify-center;
    transition: all 0.25s ease-in-out;
}
</style>

<style>
.modal-holder {
    background-color: rgba(0, 0, 0, 0.2);
}
</style>
